var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1949_183713",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 2,
    width: 15,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.12713 6.69082L4.50203 2.31583C4.67288 2.14497 4.94994 2.14492 5.12085 2.31571C5.29177 2.48651 5.29182 2.76347 5.12097 2.93433L1.49277 6.5626H13.5624C13.804 6.5626 13.9999 6.75847 13.9999 7.0001C13.9999 7.24172 13.804 7.4376 13.5624 7.4376H1.49395L5.12079 11.0623C5.2917 11.2331 5.29175 11.51 5.12091 11.6809C4.95007 11.8518 4.67303 11.8518 4.50213 11.681L0.141887 7.32342C0.136925 7.31889 0.132042 7.31423 0.127243 7.30943C-0.0436721 7.13864 -0.043723 6.86168 0.12713 6.69082Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1949_183713)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#131619"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftOutlined);
export default __webpack_public_path__ + "static/media/arrow-left-outlined.f48bf288247ea4dd190b68f7f8eea434.svg";
export { ForwardRef as ReactComponent };